import AppNavLink from 'components/Router/AppNavLink';
import { useParams } from 'react-router-dom';

const ApplicationDetailsNav = () => {
  const { applicationId, applicationFormId } = useParams<string>();
  const applicationDetailNavItems = [
    { name: 'Application Details', path: 'application_details' },
    { name: 'Due Diligence', path: 'due_diligence' },
  ];

  return (
    <>
      <div className='border-b-2 border-neutralColor-light flex gap-8 my-5 cursor-pointer'>
        {applicationDetailNavItems.map((item) => (
          <AppNavLink
            key={item.path}
            to={`/app/rover/application_forms/${applicationFormId}/applications/${applicationId}/${item.path}`}
            baseClassName='px-2 font-semibold'
            activeClassName='border-primaryColor-normal text-primaryColor-normal border-b-2 pb-2 -mb-0.5'
          >
            {item.name}
          </AppNavLink>
        ))}
      </div>
    </>
  );
};

export default ApplicationDetailsNav;
